import { useRef } from "react";
import { ImageIcon } from "lucide-react";

import { Spinner } from "@/components/ui/spinner";

/** Para el `accept` del input: extensiones, que es lo que entiende el diálogo. */
export const EXTENSIONES_ACEPTADAS = ".jpg,.jpeg,.png,.webp";

/**
 * EL RECUADRO DEL DISEÑO: una caja punteada con el ícono y el texto al centro,
 * que ES la zona de soltar. Es la pieza que comparten `TarjetaDeImagen`
 * (UNA imagen) y `GaleriaDeFotografias` (VARIAS): medidas, radio y colores
 * viven acá, en un solo lugar.
 *
 * Solo dibuja el botón: quien lo usa pone el `<input>` y el manejo del soltar.
 */
export function RecuadroPunteado({
  ocupado = false,
  marcador,
  onClick,
}: {
  ocupado?: boolean;
  marcador: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      disabled={ocupado}
      onClick={onClick}
      className="border-input bg-muted/60 text-ink-body hover:border-primary/50 focus-visible:ring-ring/50 flex size-full flex-col items-center justify-center gap-2 rounded-[0.875rem] border-[1.5px] border-dashed px-4 text-center outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-60"
    >
      {ocupado ? (
        <Spinner />
      ) : (
        <ImageIcon className="text-ink-hint size-6" strokeWidth={1.6} aria-hidden="true" />
      )}
      <span className="text-[0.8125rem] font-medium">{marcador}</span>
      <span className="text-ink-muted text-[0.6875rem] font-medium">
        o <span className="underline">busca archivos</span>
      </span>
    </button>
  );
}

/**
 * La zona de soltar COMPLETA de varias imágenes: caja de 520 × 240, `<input
 * multiple>` y soltar. Entrega la lista tal como llegó; quien la usa decide
 * cómo subirla.
 */
export function ZonaDeSoltarImagenes({
  ariaLabel,
  marcador,
  ocupado = false,
  onArchivos,
}: {
  ariaLabel: string;
  marcador: string;
  ocupado?: boolean;
  onArchivos: (archivos: File[]) => void;
}) {
  const input = useRef<HTMLInputElement>(null);

  return (
    <div
      className="relative h-60 max-w-[32.5rem] overflow-hidden rounded-[0.875rem]"
      onDragOver={(evento) => evento.preventDefault()}
      onDrop={(evento) => {
        evento.preventDefault();
        const archivos = Array.from(evento.dataTransfer.files);
        if (archivos.length > 0 && !ocupado) onArchivos(archivos);
      }}
    >
      <input
        ref={input}
        type="file"
        multiple
        accept={EXTENSIONES_ACEPTADAS}
        className="sr-only"
        aria-label={ariaLabel}
        onChange={(evento) => {
          const archivos = Array.from(evento.target.files ?? []);
          // Se limpia SIEMPRE: sin esto, volver a elegir el mismo archivo no
          // dispara `change` y reintentar tras un error sería imposible.
          evento.target.value = "";
          if (archivos.length > 0) onArchivos(archivos);
        }}
      />
      <RecuadroPunteado ocupado={ocupado} marcador={marcador} onClick={() => input.current?.click()} />
    </div>
  );
}
